import { GetTaskFilesDocument, TasksTaskFile } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export interface TaskFile extends TasksTaskFile {}

interface UseGetTaskFiles {
  files: TaskFile[]
  loading: boolean
  error: Error | undefined
}

export const useGetTaskFiles = (taskId: number): UseGetTaskFiles => {
  const { data, loading, error } = useQuery(GetTaskFilesDocument, {
    variables: { taskId },
  })

  return {
    loading,
    files: data ? (data.tasks.taskFilesConnection.nodes as TaskFile[]) : [],
    error,
  }
}
